export var ALERT_TYPE_ERROR = 'error';
export var ALERT_TYPE_WARNING = 'warning';
export var ALERT_TYPE_SUCCESS = 'success';
export var ALERT_TYPE_INFO = 'info';
export var ALERT_TYPE_DANGER = 'danger'; // deprecated!!!

export var ALERT_TYPES = [ALERT_TYPE_ERROR, ALERT_TYPE_WARNING, ALERT_TYPE_SUCCESS, ALERT_TYPE_INFO];

export var DEPRECATED_ALERT_TYPES = [ALERT_TYPE_DANGER];


//////////////////
// WEBPACK FOOTER
// ./node_modules/patternfly-react/dist/esm/components/Alert/AlertConstants.js
// module id = 262
// module chunks = 0